module.exports = __webpack_public_path__ + "img/mask-group.96b494a1.png";